import cn from 'classnames';
import {useEffect, useState} from 'react';

interface IFloatingOnlySelectBottomSheetProps {
  Placeholder?: string;
  title?: string | null;
  readonly?: boolean;
  value?: string;
  require?: boolean;
  wrapperClass?: string;
  onClick?: () => void;
  name?: string;
  errors?: string | undefined | boolean;
  disabled?: boolean;
}

function FloatingOnlySelectBottomSheet({
  Placeholder,
  title,
  readonly,
  value = '',
  require = false,
  wrapperClass,
  name,
  onClick,
  errors,
  disabled = false,
}: IFloatingOnlySelectBottomSheetProps) {
  const [inputVal, setInputVal] = useState(value);

  useEffect(() => {
    setInputVal(value);
  }, [value]);

  return (
    <div className="w-full">
      <div
        className={cn(
          'flex border-[1px] h-[50px] w-full items-center p-2 rounded relative border-gray-700',
          wrapperClass,
          {
            'border-red-550': errors,
            '!border-farm-shop-500': !errors && value,
            '!border-gray-300 text-gray-200': disabled,
          },
        )}
        onClick={!disabled ? onClick : () => null}
      >
        {title && inputVal && (
          <label
            className={cn(
              'absolute top-0 px-1 text-sm bg-white -translate-y-1/2 w-fit text-farm-shop-500',
              {'text-gray-300': disabled},
            )}
          >
            {title}
            <span className="text-red-500">{require ? '*' : ''}</span>
          </label>
        )}
        <input
          className="w-full bg-transparent outline-none pointer-events-none text-md placeholder:text-gray-700"
          value={inputVal}
          placeholder={!inputVal ? Placeholder : ''}
          onChange={e => {
            setInputVal(e.target.value);
          }}
          readOnly
        />
        <i className="icon-nameArrow---Down-2-1" />
      </div>
      {errors && <span className="text-sm text-red-550">{errors}</span>}
    </div>
  );
}

export default FloatingOnlySelectBottomSheet;
